
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exhibitors/[exhibitor_id]",
      function () {
        return require("private-next-pages/exhibitors/[exhibitor_id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exhibitors/[exhibitor_id]"])
      });
    }
  